module.exports = __webpack_public_path__ + "static/media/PrecentLetters.5d2b6007.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/PrecentLetters.svg
// module id = 197
// module chunks = 0